import { nanoid } from 'nanoid';
import React from 'react';

export interface ComponentProps {
  type: string;
}

export const getComponent = (node: ComponentProps, components: Map<string, any>) => {
  if (components.has(node.type)) {
    const Component = components.get(node.type);

    return <Component key={nanoid()} node={node} />;
  }
};
